import React from "react";
import { useStore } from "@/context/StoreContext";
import { BookOpen, Phone, MessageCircle, Wrench } from "lucide-react";

export default function Maintenance() {
  const { settings } = useStore();
  const whatsappNumber = (settings?.whatsapp || "").replace(/[^0-9]/g, "");
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-brand-blue px-6 text-center relative overflow-hidden" data-testid="maintenance-page">
      <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full bg-brand-gold/10" />
      <div className="absolute -bottom-24 -right-24 w-72 h-72 rounded-full bg-brand-gold/10" />

      <div className="relative z-10 max-w-xl">
        <div className="inline-flex items-center gap-2 mb-8">
          <span className="w-12 h-12 flex items-center justify-center bg-brand-gold border-2 border-black rounded-md shadow-brutal-black">
            <BookOpen className="w-6 h-6 text-brand-blue" strokeWidth={2.5} />
          </span>
          <span className="font-display font-black text-2xl text-white">
            Books<span className="text-brand-gold">N</span>more
          </span>
        </div>

        <span className="inline-flex items-center gap-2 bg-brand-gold text-black text-sm font-bold px-4 py-1.5 border-2 border-black rounded-full mb-6">
          <Wrench className="w-4 h-4" /> Under maintenance
        </span>

        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight text-white leading-tight">
          We'll be back shortly
        </h1>
        <p className="mt-5 text-white/70 text-lg leading-relaxed">
          Our website is getting a quick update. In the meantime, you can still reach us to place an order or ask a question.
        </p>

        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          {settings?.phone && (
            <a href={`tel:${settings.phone}`} data-testid="maintenance-call-btn" className="inline-flex items-center gap-2 bg-brand-gold text-black font-semibold px-6 py-3 border-2 border-black rounded-md shadow-brutal-black hover:-translate-y-0.5 transition-all">
              <Phone className="w-5 h-5" /> {settings.phone}
            </a>
          )}
          {whatsappNumber && (
            <a href={`https://wa.me/${whatsappNumber}`} target="_blank" rel="noopener noreferrer" data-testid="maintenance-whatsapp-btn" className="inline-flex items-center gap-2 bg-[#25D366] text-white font-semibold px-6 py-3 border-2 border-black rounded-md shadow-brutal-black hover:-translate-y-0.5 transition-all">
              <MessageCircle className="w-5 h-5" /> WhatsApp us
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
